import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DefaultTopLevelGroup, Status } from "../../common/constants";
import { listAlertsUrl } from "../../config";
import { IAlerts, IAlertsApi } from "./utils";
import { RootState } from "../../store";
import api from '../../api';

const GET_ALERTS = "getAlerts"

const initialState: IAlerts = {
  alerts: null,
  status: Status.IDLE,
  error: null,
  pageIndex: 0,
  pageSize: 10,
  totalCount: 0,
  alertGroupOptions: [],
  newlyCreatedAlertId: null
};

export interface IListAlertPayload {
  pageIndex?: number;
  pageSize?: number;
  globalFilter?: string;
  columnFilters?: any[];
}


export const fetchAlertsData = createAsyncThunk<any,IListAlertPayload|undefined|void>(
  GET_ALERTS,
  async (payload:IListAlertPayload|null|undefined) => {
    try {
      let params="";
      if(payload)
      {
       const urlParams=new URLSearchParams({
        page: payload?.pageIndex?.toString() || '0',
        pageSize: payload?.pageSize?.toString() || '50'
      })
      const normalizedGlobalFilter = payload?.globalFilter?.trim();

      if (normalizedGlobalFilter) {
          urlParams.append("globalFilter", normalizedGlobalFilter);
        }
      payload?.columnFilters?.forEach((filter)=>{
        urlParams.append(filter.id,filter.value);
      })
      params=`&${urlParams.toString()}`
    }
      const response = await api.get(listAlertsUrl + `?orgId=${DefaultTopLevelGroup.ID}${params}`);
      const alertsData: any = response.data;
      return alertsData;
    } catch (error) {
      throw error;
    }
  }
);

const alertsSlice = createSlice({
  name: GET_ALERTS,
  initialState,
  reducers: {
    setNewlyCreatedAlertId: (state, action) => {
      state.newlyCreatedAlertId = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAlertsData.pending, (state) => {
        state.status = Status.PENDING;
      })
      .addCase(fetchAlertsData.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        if(action.payload.totalCount !== undefined) {
          state.totalCount = action.payload.totalCount;
        }
        if(action.payload.page !== undefined) {
          state.pageIndex = action.payload.page;
        }
        if(action.payload.pageSize !== undefined) {
          state.pageSize = action.payload.pageSize;
        }
         if(action.payload.alertGroupOptions!==undefined && Array.isArray(action.payload.alertGroupOptions)) {
          state.alertGroupOptions = action.payload.alertGroupOptions;
        }
        if(action.payload.data!==undefined && Array.isArray(action.payload.data)) {
          state.alerts = action.payload.data;
        }
        else
        state.alerts = action.payload;
      })
      .addCase(fetchAlertsData.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = action.error.message;
      });
  },
});

export const selector = (state: RootState) => state.alertsApi;

export const reducer = alertsSlice.reducer;

export const { setNewlyCreatedAlertId } = alertsSlice.actions;
